import React, { useEffect } from 'react';
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css'; // AOS Styles

function ContentHome() {
  useEffect(() => {
    AOS.init({
      duration: 2000, // Animation duration
      once: true, // Animation should only happen once
    });
  }, []);

  return (
    <Container>
      <Outer>
        <Dot />
        <Wrap>
          <Ray />
          <h1 className='shine' data-aos="fade-up">Cinematic Video Production Company</h1>
          <p data-aos="fade-up" data-aos-delay="100">
            IBEX FILMZ is a leading Video Production Company based in Colombo, Sri Lanka. We are a dynamic team of passionate and experienced young talents, capable of delivering widely diverse and captivating videos that you could ever imagine. As videos are now more accessible than ever, we help brands and organizations to create powerful videos/ films that communicate their vision, mission, and services using a narrative approach of storytelling.
          </p>
          <p data-aos="fade-up" data-aos-delay="200">
            Our specialization includes Corporate Video Productions, Resort & Real Estate Video Productions, Documentary Films, Action Sports Video Production , Product Commercials, Destination Promotional Videos, and Aerial Cinematography.
          </p>
          <p data-aos="fade-up" data-aos-delay="300">
            At IBEX FILMZ, we understand the importance of creating videos that not only grab attention but also leave a lasting impact. Our collaborative approach ensures that we understand your unique objectives, target audience, and brand identity, allowing us to tailor our services to meet your specific needs and exceed your expectations.
          </p>
          <p data-aos="fade-up" data-aos-delay="400">
            Whether you're a startup looking to make a splash in the market or an established brand aiming to revitalize your video marketing strategy, we have the creativity, technical prowess, and dedication to bring your ideas to life. Get ready to amaze the video marketing world and captivate your audience with our innovative and compelling creations.
          </p>
          <p data-aos="fade-up" data-aos-delay="500">
            Reach out to IBEX FILMZ today, and let's embark on a journey to elevate your brand through the power of video storytelling.
          </p>
          <Line className="topl" />
          <Line className="leftl" />
          <Line className="bottoml" />
          <Line className="rightl" />
        </Wrap>
      </Outer>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  background: #08090A;
  z-index: 2;
  position: relative;
  padding-top: 150px;

  @media (max-width: 1024px) {
    padding-top: 120px;
  }

  @media (max-width: 768px) {
    padding-top: 100px;
  }
`;

const Outer = styled.div`
  width: 90%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Dot = styled.div`
  width: 5px;
  aspect-ratio: 1;
  position: absolute;
  background-color: var(--secondary-color);
  box-shadow: 0 0 10px #ffffff;
  border-radius: 100px;
  z-index: 2;
  right: 10%;
  top: 10%;
  animation: moveDot 6s linear infinite;
  
  @keyframes moveDot {
    0%, 100% {
      top: 10%;
      right: 10%;
    }
    25% {
      top: 10%;
      right: calc(90% - 35px);
    }
    50% {
      top: calc(100% - 30px);
      right: calc(90% - 35px);
    }
    75% {
      top: calc(100% - 30px);
      right: 10%;
    }
  }

  @media (max-width: 1024px) {
    right: 15%;
    top: 15%;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const Wrap = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 50px 40px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;

  h1 {
    font-size: 48px;
    margin: 30px 0;
    color: white;
    text-align: center;
    text-transform: uppercase;

    @media (max-width: 1024px) {
      font-size: 40px;
    }

    @media only screen and (max-width: 768px) {
      font-size: 28px;
    }
  }

  p {
    font-size: 16px;
    padding: 10px 90px;
    text-align: center;
    line-height: 2.2rem;
    color: #b5b5b7;

    @media (max-width: 1024px) {
      font-size: 14px;
      padding: 10px 60px;
    }

    @media only screen and (max-width: 768px) {
      font-size: 12px;
      padding: 0 20px;
    }
  }

  @media only screen and (max-width: 1200px) {
    padding: 15px;
    width: 98%;
  }
`;

const Ray = styled.div`
  width: 220px;
  height: 45px;
  border-radius: 100px;
  position: absolute;
  background-color: #c7c7c7;
  opacity: 0.4;
  box-shadow: 0 0 50px #fff;
  filter: blur(10px);
  transform-origin: 10%;
  top: 0%;
  left: 0;
  transform: rotate(40deg);

  @media (max-width: 1024px) {
    width: 180px;
    height: 40px;
    top: 5%;
    left: 5%;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  position: absolute;
  background-color: #2c2c2c;

  &.topl {
    top: 10%;
    background: linear-gradient(90deg, #888888 30%, #1d1f1f 70%);
  }

  &.bottoml {
    bottom: 10%;
  }

  &.leftl {
    left: 10%;
    width: 1px;
    height: 100%;
    background: linear-gradient(180deg, #747474 30%, #222424 70%);
  }

  &.rightl {
    right: 10%;
    width: 1px;
    height: 100%;
  }

  @media (max-width: 1024px) {
    left: 12%;
    right: 12%;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export default ContentHome;
